export default __webpack_public_path__ + "static/media/seba.954e45ff.jfif";